export default "__VITE_ASSET__Bn5TRey9__"